import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/app.component";
import { store } from "@/app/app.store";

import { I18nextProvider } from "react-i18next"; // Importa el proveedor de i18next
import i18n from "@/app/i18n"; // Importa la instancia configurada de i18next

import "./index.css";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <App />
        <Toaster />
      </Provider>
    </I18nextProvider>
  </StrictMode>
);
